<template>
	<v-layout 
		wrap 
		class="section-help container"
		:class="{'gray': gray}"
		id="help">
		<v-flex xs12 mb-5>
			<v-layout wrap justify-center>
				<v-flex xs12 md4 lg3 class="wrapper-titles">
					<p class="mb-0 subtitle-help">TE PRESENTAMOS A NUESTRA APP</p>
					<p class="mb-0 title-help">BENEFICIOS</p>
				</v-flex>
				<v-flex xs12 md6>
					<p class="mb-0 sub-subtitle-help">Permitirás a clientes de siempre, hacer sus pedidos desde la comodidad de su casa, de manera segura y sin colas.</p>
				</v-flex>
			</v-layout>
		</v-flex>	
		<v-flex xs12 md7 lg6>
			<v-layout wrap class="wrapper-mobile">
				<v-flex class="w-33 mr-2 mb-1">
					<div class="wrapper-text-card">
						<img :src="`${$S3}card-icon-1.png`" alt="fidelizar" height="38">
						<p class="center text-green">Fidelizar a <br/>tus clientes</p>
					</div>
				</v-flex>
				<v-flex class="w-33 mr-2 mb-1">
					<div class="wrapper-text-card">
						<img :src="`${$S3}card-icon-10.svg`" alt="crédito" height="38">
						<p class="center text-green">Incrementar<br/>tus ventas</p>
					</div>
				</v-flex>
				<v-flex class="w-33 mr-2 mb-1">
					<div class="wrapper-text-card">
						<img :src="`${$S3}card-icon-11.svg`" alt="pago en línea" height="38">
						<p class="center text-green">Facilitar a tus clientes<br/>con todos los medios<br/>de pago.</p>
					</div>
				</v-flex>
				<v-flex class="w-33 mr-2 mb-1">
					<div class="wrapper-text-card">
						<img :src="`${$S3}card-icon-4.png`" alt="ganar tiempo" height="38">
						<p class="center text-green">Gestionar tus pedidos<br/>de manera más rápida y <br/>organizada</p>
					</div>
				</v-flex>
				<v-flex class="w-33 mr-2 mb-1">
					<div class="wrapper-text-card">
						<img :src="`${$S3}card-icon-16.svg`" alt="ganar tiempo" height="38">
						<p class="center text-green">Contar con un listado<br/>de datos de productos<br/>con imágenes</p>
					</div>
				</v-flex>
				<v-flex class="w-33 mr-2 mb-1">
					<div class="wrapper-text-card">
						<img :src="`${$S3}card-icon-13.svg`" alt="programar compras" height="38">
						<p class="center text-green">Manejar de<br/>manera más<br/>eficiente tu stock</p>
					</div>
				</v-flex>
				<v-flex class="w-33 mr-2 mb-1" v-if="!isPeru">
					<div class="wrapper-text-card">
						<img :src="`${$S3}card-icon-14.svg`" alt="manejar stock" height="38">
						<p class="center text-green">Hacer <br/>facturas <br/>electrónicas.</p>
					</div>
				</v-flex>
				<v-flex class="w-33 mr-2 mb-1">
					<div class="wrapper-text-card">
						<img :src="`${$S3}card-icon-12.svg`" alt="ofertas" height="38">
						<p class="center text-green">Ofertar productos de<br/>mayor rotación y antes<br/>de que caduquen.</p>
					</div>
				</v-flex>
				<v-flex class="w-33 mr-2 mb-1">
					<div class="wrapper-text-card">
						<img :src="`${$S3}card-icon-15.svg`" alt="ganar tiempo" height="38">
						<p class="center text-green"> Cuidar a tus vecinos y <br/>a ti mismo, ayudando al <br/>aislamiento social.</p>
					</div>
				</v-flex>
			</v-layout>
			<div class="center center-btn-section" v-if="$route.name === 'page-home'">
				<a class="btn-section bold" href="#banner">Solicita tu app</a>
			</div>
		</v-flex>
		<v-flex xs12 md5 lg6 pl-3 class="slider-order">
			<div class="wrapper-slider-order">
				<slider animation="fade" :speed="2000" height="100%">
					<slider-item>
						<div class="center">
							<img
								src="https://makiperesel-landing.s3-sa-east-1.amazonaws.com/Imagenes/slide1-min.png" 
								alt="slide-1"
								class="img-slider"
							>
						</div>
					</slider-item>
					<slider-item>
						<div class="center">
							<img
								:src="`${$S3}slide-image-2-min.png`" 
								alt="slider-2"
								class="img-slider"
							>
						</div>
					</slider-item>
					<slider-item>
						<div class="center">
							<img
								:src="`${$S3}slide-image-3-min.png`" 
								alt="slider-3"
								class="img-slider"
							>
						</div>
					</slider-item>
				</slider>
			</div>
		</v-flex>
	</v-layout>
</template>
<script>
function data() {
	return {
		swiperOptions: {
			spaceBetween: 30,
			centeredSlides: true,
			autoplay: {
				delay: 10500,
				disableOnInteraction: true,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		},
	};
}

export default {
	name: 'section-help',
	data,
	props: {
		gray: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style lang="scss" scoped>
	.section-help {
		margin-top: -70px;
		padding: 180px 7% 92px;

		&.gray {
			background-color: color(back-gray-l);
		}

		@media (max-width: 934px) {
			padding: 130px 5% 82px;
		}

		@media (min-width: 1350px) {
			padding: 180px 0 92px;
		}

		.title {
			color: color(title-green);
			font-family: font(lato-regular);
			font-weight: 600;
			text-transform: uppercase;

			@media (max-width: 936px) {
				text-align: center;
			}
		}

		.text {
			font-family: font(lato-regular);
			line-height: 27px;
			width: 50%;

			@media (max-width: 936px) {
				width: 100%;
				padding-left: 0px !important;
				text-align: center;
			}
		}

		.bold {
			font-family: font(lato-regular);
			font-weight: 600;
		}

		.wrapper-image {
			height: 100%;
			position: relative;
			width: 100%;

			@media (max-width: 936px) {
				display: none;
			}
		}

		.image {
			bottom: 0;
			max-height: 100%;
			max-width: 100%;
			position: absolute;
		}

		.wrapper-image-mobile {
			display: none;
			height: 257px;

			@media (max-width: 936px) {
				display: block;
			}
		}

		.image-mobile {
			max-height: 100%;
			max-width: 100%;
		}
	}

	.slider-order {
		font-family: font(lato-regular);

		.title {
			color: color(green-dark);
			font-size: 32px !important;
			font-weight: 600;
		}

		.subtitle {
			font-size: 20px !important;
		}

		.bold {
			font-weight: 600;
		}

		.wrapper-text {
			background-color: color(white);
			border-radius: 9px;
			box-shadow: 0 2px 19px 0 rgba(234, 234, 234, 0.5);
			padding: 47px 32px;
		}

		.img-slider {
			height: 480px;
		}

		.wrapper-slider-order {
			height: 100%;
			position: relative;

			@media (max-width: 936px) {
				padding-top: 65px;
				height: 546px;
			}
		}
	}

	.w-50 {
		width: 50%;

		@media (max-width: 936px) {
			width: 100%;
		}
	}

	.w-33 {
		max-width: 160px;
		min-width: 160px;

		@media (max-width: 934px) {
			margin-right: 0px !important;
		}
	}

	.wrapper-text-card {
		border-radius: 9px;
		box-shadow: 0 2px 19px 0 rgba(234, 234, 234, 0.5);
		height: 160px;
		padding: 25px 0px 14px;
		text-align: center;
		width: 160px;
	}

	.btn-section {
		background: color(green-link);
		border-radius: 9px;
		color: color(white);
		font-family: font(lato-regular);
		font-size: size(medium18);
		font-weight: map-get($weight, w900);
		display: inline-block;
		margin: 25px 0 0;
		padding: 15px 0;
		text-decoration: none;
		width: 227px;

		@media (max-width: 934px) {
			margin: 21px 0px 0px;
		}
	}

	.text-green {
		color: color(title-green);
		font-family: font(lato-regular);
		font-size: size(medium);
		line-height: normal;
		margin-top: 20px;
		min-height: 59px;
		padding: 0px;
	}

	.center {
		text-align: center;
	}

	.title-help {
		color: color(green-dark);
		font-family: font(lato-regular);
		font-size: size(large48);
		font-weight: map-get($weight, w900);
		line-height: normal;
		margin-bottom: 35px;
		text-transform: uppercase;

		@media (max-width: 934px) {
			font-size: size(large29);
		}
	}

	.subtitle-help {
		color: color(green-dark);
		font-family: font(lato-regular);
		font-size: size(medium18);
		font-weight: map-get($weight, w600);
		line-height: normal;
		margin-bottom: 52px;
	}

	.wrapper-mobile {
		justify-content: center;

		@media (max-width: 934px) {
			padding: 0px;
		}
	}

	.center-btn-section {
		padding-right: 45px;

		@media (max-width: 934px) {
			padding-right: 0px;
		}
	}

	.wrapper-titles {
		border-right: 2px solid map-get($colors, green-dark);

		@media (max-width: 934px) {
			border-right: none;
			text-align: center;
		}
	}

	.sub-subtitle-help {
		color: map-get($colors, form-grey);
		font-size: map-get($sizes, medium18);
		padding: 10px 30px;

		@media (max-width: 934px) {
			text-align: center;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-help.vue